import React from 'react'
import { useNavigate } from 'react-router-dom'
import type { Track } from 'types/track'
import { useMenu } from 'components/ds'

type Props = {
  closeMenu: () => void
  disabled: boolean
  manageNesting: boolean
  trackNestingEnabled: boolean
  track: Track
}

const ManageNesting = ({
  manageNesting,
  trackNestingEnabled,
  disabled,
  track,
}: Props): React.ReactNode => {
  const Menu = useMenu()
  const navigate = useNavigate()
  if (!manageNesting || !trackNestingEnabled || !track?.permissions?.manage)
    return null

  const manageNestingId = track.nesting_parent_id || track.id
  return (
    <Menu.Item
      disabled={disabled}
      onSelect={() =>
        navigate(`/explorer/tracks/${manageNestingId}/manage-nesting`)
      }
    >
      Nesting
    </Menu.Item>
  )
}

export default ManageNesting
